import {HttpClient, HttpErrorResponse, HttpParams} from '@angular/common/http';
import {Injectable} from '@angular/core';
import {Observable} from 'rxjs/Observable';

import {BACKEND_KEYS, BACKEND_METHOD_CONSTANT, BACKEND_METHOD_TYPES, URL_CONSTANT} from './url-constant';

import {BaseAPI} from './baseAPI';
import {ModuleModel} from '../models/module.model';
import {AuthService} from './auth.service';
import {UserModel} from '../models/user.model';
import {RegionModel} from '../models/region.model';
import * as underscore from 'underscore';
import {map} from 'rxjs/operators';
import {UserSiteModel} from '../models/user-site.model';
import {SiteModel} from '../models/site.model';
import {NewUsersModel} from "../models/new-users.model";
import {DataService} from "./data.service";


@Injectable()
export class UsersService extends BaseAPI {

  constructor(public http: HttpClient, public authService: AuthService) {
    super(http, authService);
  }

  getUsers(): Observable<UserModel[]> {
    const httpParams = this.getBaseHttpParams();

    // if (siteId != null) {
    //   httpParams = httpParams.set(BACKEND_KEYS.siteId, String(siteId))
    // }
    // if (filterId != null) {
    //   httpParams = httpParams.set(BACKEND_KEYS.filterId, String(filterId));
    // }

    const url = BACKEND_METHOD_CONSTANT.user + BACKEND_METHOD_TYPES.list;

    return this.get(url, httpParams).pipe(map((users: UserModel[]) => {
      return users ? users : undefined;
    }))
      .catch(this.handleError);
  }

  getNewUsers(): Observable<NewUsersModel> {
    const httpParams = this.getBaseHttpParamsWithoutPlatform();

    const url = BACKEND_METHOD_CONSTANT.users;

    return this.getMaster(url, httpParams).pipe(map((users: NewUsersModel) => {
      return users ? users : undefined;
    }))
      .catch(this.handleError);
  }

  getDistributorClients(userId: number): Observable<UserModel[]> {
    const httpHeaders = this.authHeader(this.authService.user.username, this.authService.user.password);
    const httpParams = new HttpParams().set(BACKEND_KEYS.distributorUserId, String(userId));
    const url = BACKEND_METHOD_CONSTANT.distributor + BACKEND_METHOD_TYPES.clients;

    return this.getMaster(url, httpParams, httpHeaders).pipe(map((users: UserModel[]) => {
      return users ? users : undefined;
    }))
      .catch(this.handleError);
  }


  getSiteUsers(userId?: number, siteId?: number): Observable<UserSiteModel[]> {
    let httpParams = this.getBaseHttpParams();

    if (siteId != null) {
      httpParams = httpParams.set(BACKEND_KEYS.siteId, String(siteId));
    }
    if (userId != null) {
      httpParams = httpParams.set(BACKEND_KEYS.userId, String(userId));
    }

    const url = BACKEND_METHOD_CONSTANT.userSite + BACKEND_METHOD_TYPES.list;

    return this.get(url, httpParams).pipe(map((users: UserSiteModel[]) => {
      return users ? users : undefined;
    }))
      .catch(this.handleError);
  }

  getUser(userId: number): Observable<UserModel> {
    const httpParams = this.getBaseHttpParams()
      .set(BACKEND_KEYS.userId, String(userId));

    const url = BACKEND_METHOD_CONSTANT.user + BACKEND_METHOD_TYPES.get;

    return this.get(url, httpParams).pipe(map((object: UserModel) => {
      return object ? object : undefined;
    }))
      .catch(this.handleError);
  }

  createUser(user: UserModel): Observable<UserModel> {
    const httpParams = this.getBaseHttpParams();

    //    @weakify(self);

    const url = BACKEND_METHOD_CONSTANT.user + BACKEND_METHOD_TYPES.create;

    return this.post(url, httpParams, user).pipe(map((object: UserModel) => {
      // console.log('new user method: ', object.userId);

      return object ? object : undefined;
    }))
      .catch(this.handleError);
  }

  updateUser(user: UserModel): Observable<UserModel> {
    const httpParams = this.getBaseHttpParams();

    //    @weakify(self);
    // console.log("user update: ", user);

    const url = BACKEND_METHOD_CONSTANT.user + BACKEND_METHOD_TYPES.update;

    return this.put(url, httpParams, user).pipe(map((object: UserModel) => {
      // console.log(object);
      return object ? object : undefined;
    }))
      .catch(this.handleError);
  }

  deleteUser(userId: number): Observable<UserModel> {
    const httpParams = this.getBaseHttpParams()
      .set(BACKEND_KEYS.userId, String(userId));

    // console.log(httpParams);

    const url = BACKEND_METHOD_CONSTANT.user + BACKEND_METHOD_TYPES.delete;

    return this.delete(url, httpParams)
      .catch(this.handleError);
  }

  // activateSensorAlarms

  // static NSString* kDFBackendDeleteAssociationWithSite = @"DeleteAssociationWithSite";
  // static NSString* kDFBackendCreateAssociationWithSite = @"CreateAssociationWithSite";

  associateSiteToUser(siteId: number, userId: number, activateSensorAlarms: boolean): Observable<any> {
    const httpParams = this.getBaseHttpParams()
      .set(BACKEND_KEYS.userId, userId.toString())
      .set(BACKEND_KEYS.siteId, siteId.toString())
      .set(BACKEND_KEYS.activateSensorAlarms, activateSensorAlarms ? '1' : '0');

    const url = BACKEND_METHOD_CONSTANT.user + '/' + BACKEND_METHOD_CONSTANT.createAssociationWithSite;

    return this.post(url, httpParams).pipe(map((result: any) => {
      return result ? result : undefined;
    }))
      .catch(this.handleError);
  }

  disassociateSiteFromUser(userId: number, siteId: number): Observable<any> {
    const httpParams = this.getBaseHttpParams()
      .set(BACKEND_KEYS.userId, userId.toString())
      .set(BACKEND_KEYS.siteId, siteId.toString());

    const url = BACKEND_METHOD_CONSTANT.user + '/' + BACKEND_METHOD_CONSTANT.deleteAssociationWithSite;

    return this.delete(url, httpParams)
      .pipe(map((result: any) => {
        return result ? result : undefined;
      }))
      .catch(this.handleError);
  }

  getUserFromId(userId: number, users: UserModel[]): UserModel {
    for (const user of users) {
      if (userId === user.userId) {
        return user;
      }
    }
    return null;
  }

  updateUserSite(userSite: UserSiteModel): Observable<UserSiteModel> {
    const httpParams = this.getBaseHttpParams();

    //    @weakify(self);

    // console.log(site)

    const url = BACKEND_METHOD_CONSTANT.userSite + BACKEND_METHOD_TYPES.update;

    return this.put(url, httpParams, userSite).pipe(map((obj: UserSiteModel) => {
      // console.log('obj: ', obj);
      return obj ? obj : undefined;
    }))
      .catch(this.handleError);
  }

  getUserTypeList(): Observable<any> {
    const httpParams = this.getBaseHttpParamsWithoutPlatform();

    const url = BACKEND_METHOD_CONSTANT.userTypes + '/';

    return this.getMaster(url, httpParams).pipe(map((res: any) => {
      return res ? res : undefined;
    }))
    .catch(this.handleError);
  }
}
